// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".7c1ba77c68c8a803b58c75f3019b0dbb20257fe7.chunk.js";
};